
export default function Footer() {
  return (
    <footer className="bg-stone-100 text-gray-800 py-8 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-6 md:mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-3 md:mb-4">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center">
                <i className="ri-scales-3-line text-2xl md:text-3xl text-red-600"></i>
              </div>
              <span className="text-lg md:text-xl font-bold text-gray-900">사법정의를 위한 국민연대</span>
            </div>
            <p className="text-gray-500 text-xs md:text-sm leading-relaxed">
              삼권분립을 지키고 사법부의 독립을 수호하기 위한 국민들의 연대
            </p>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 text-gray-900">바로가기</h3>
            <ul className="space-y-1.5 md:space-y-2 text-xs md:text-sm">
              <li>
                <a href="#declaration" className="text-gray-500 hover:text-red-600 transition-colors cursor-pointer">
                  선언서
                </a>
              </li>
              <li>
                <a href="#statistics" className="text-gray-500 hover:text-red-600 transition-colors cursor-pointer">
                  참여현황
                </a>
              </li>
              <li>
                <a href="#timeline" className="text-gray-500 hover:text-red-600 transition-colors cursor-pointer">
                  타임라인
                </a>
              </li>
              <li>
                <a href="#resources" className="text-gray-500 hover:text-red-600 transition-colors cursor-pointer">
                  자료실
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 text-gray-900">문의</h3>
            <p className="text-xs md:text-sm text-gray-500 mb-4 md:mb-6">
              이메일: <a href="mailto:100justicekorea@gmail.com" className="hover:text-red-600 transition-colors">100justicekorea@gmail.com</a>
            </p>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 text-gray-900">SNS 커뮤니티</h3>
            <div className="flex space-x-4 mt-1">
              <a href="https://t.me/+1WdQdYGXQFU2NmE1" target="_blank" rel="noopener noreferrer" className="w-12 h-12 md:w-14 md:h-14 bg-gray-200 rounded-full flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors cursor-pointer">
                <i className="ri-telegram-fill text-2xl md:text-3xl"></i>
              </a>
              <a href="https://open.kakao.com/o/gE2hVphi" target="_blank" rel="noopener noreferrer" className="w-12 h-12 md:w-14 md:h-14 bg-gray-200 rounded-full flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors cursor-pointer">
                <i className="ri-kakao-talk-fill text-2xl md:text-3xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center text-xs md:text-sm text-gray-400 gap-3 md:gap-0">
          <p className="text-center md:text-left">&copy; 2025 사법정의를 위한 국민연대. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
